import { useTranslation } from 'react-i18next'
import styles from './index.module.less'
import emptyImg from '@/assets/image/gea/empty_new.png'

interface IProps {
  text?: string // 缺省文本
}
const MeEmpty = ({ text }: IProps) => {
  const { t } = useTranslation()
  return (
    <div className={styles.empty_warp}>
      <img className={styles.empty_img} src={emptyImg} />
      <div className={styles.empty_text}>{text || t('explorer_233')}</div>
    </div>
  )
}

export default MeEmpty
